import { ApplicationInfoTabProps } from 'features/Principal/types/modalTypes';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { Box, Link, Stack, Typography, useTheme } from '@mui/material';
import { Key, SubHeader } from '../../styles';

export const ApplicationInfoTab: React.FC<ApplicationInfoTabProps> = ({
  customAnswers,
  nimbleAnswers,
  videoUrls,
}) => {
  const theme = useTheme();

  const hasCustomAnswers = customAnswers && customAnswers.length > 0;
  const hasNimbleAnswers = nimbleAnswers && nimbleAnswers.length > 0;
  const hasVideoUrls = videoUrls && videoUrls.length > 0;

  if (!hasCustomAnswers && !hasVideoUrls && !hasNimbleAnswers)
    return (
      <Typography
        data-testid={ATSPrincipalAppCandidateModalTabsTestIds.APPLICATION_INFO_EMPTY_STATE}
      >
        No questions were asked on this application.
      </Typography>
    );

  return (
    <>
      {hasNimbleAnswers && (
        <>
          <SubHeader
            data-testid={ATSPrincipalAppCandidateModalTabsTestIds.PROFILE_QUESTIONS_SECTION}
            variant="h3"
            sx={{ mb: 2 }}
          >
            Profile Questions
          </SubHeader>
          <Box>
            {nimbleAnswers.map((answer, index) => (
              <Box key={index} sx={{ pb: 2 }}>
                <Key
                  variant="body2"
                  data-testid={ATSPrincipalAppCandidateModalTabsTestIds.NIMBLE_QUESTION}
                >
                  {answer.question}
                </Key>
                <Typography
                  sx={{ lineHeight: 1.625, pt: 1, color: theme.palette.text.tertiary }}
                  data-testid={ATSPrincipalAppCandidateModalTabsTestIds.NIMBLE_ANSWER}
                >
                  {answer.answer}
                </Typography>
              </Box>
            ))}
          </Box>
        </>
      )}
      {(hasCustomAnswers || hasVideoUrls) && (
        <>
          <SubHeader
            data-testid={ATSPrincipalAppCandidateModalTabsTestIds.APPLICATION_QUESTIONS_SECTION}
            variant="h3"
            sx={{ mb: 2 }}
          >
            Application Questions
          </SubHeader>
          <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.APPLICATION_INFO_TAB}>
            {customAnswers?.map((answer) => (
              <Box key={answer.order} sx={{ pb: 2 }}>
                <Key
                  variant="body2"
                  data-testid={ATSPrincipalAppCandidateModalTabsTestIds.APPLICATION_QUESTION}
                >
                  {answer.question}
                </Key>
                <Typography
                  sx={{ lineHeight: 1.625, pt: 1, color: theme.palette.text.tertiary }}
                  data-testid={ATSPrincipalAppCandidateModalTabsTestIds.APPLICATION_ANSWER}
                >
                  {answer.answer}
                </Typography>
              </Box>
            ))}
            {videoUrls && (
              <>
                {videoUrls.map((video) => (
                  <Stack direction="column" key={video.id} sx={{ pb: 2 }}>
                    <Key
                      sx={{ fontSize: theme.typography.heading7.fontSize }}
                      data-testid={ATSPrincipalAppCandidateModalTabsTestIds.VIDEO_TITLE}
                    >
                      {video.title}
                    </Key>
                    <Link
                      target="_blank"
                      href={video.video_url}
                      sx={{ lineHeight: 1.625, pt: 1, color: theme.palette.text.tertiary }}
                      data-testid={ATSPrincipalAppCandidateModalTabsTestIds.VIDEO_LINK}
                    >
                      {video.video_url}
                    </Link>
                  </Stack>
                ))}
              </>
            )}
          </Box>
        </>
      )}
    </>
  );
};
